export const ITEM_SIZE_EXTRA_LARGE = 'xl';
export const ITEM_SIZE_LARGE = 'l';
export const ITEM_SIZE_MEDIUM = 'm';
export const ITEM_SIZE_SMALL = 's';

export const ITEM_TYPE_DEFAULT = 'defalut';
export const ITEM_TYPE_ICON = 'icon';
export const ITEM_TYPE_CHECKBOX = 'checkbox';
export const ITEM_TYPE_RADIO = 'radio';

export const ITEM_ALIGN_TOP = 'top';
export const ITEM_ALIGN_CENTER = 'center';
export const ITEM_ALIGN_BOTTOM = 'bottom';
